"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cpfCnpjValidator = exports.stringAsNum = exports.removeCpfCharacters = void 0;
const zod_1 = require("zod");
const removeCpfCharacters = (val) => val.replace(/[./-]/g, '');
exports.removeCpfCharacters = removeCpfCharacters;
const stringAsNum = (preTransform) => zod_1.z
    .union([zod_1.z.string(), zod_1.z.number()])
    .transform((val, ctx) => {
    if (typeof val === 'number')
        return val;
    const value = preTransform?.(val) ?? val;
    const valueAsNumber = Number(value);
    if (Number.isNaN(valueAsNumber)) {
        ctx.addIssue({ code: 'custom', message: 'should be parseable to a number' });
        return zod_1.z.NEVER;
    }
    return valueAsNumber;
})
    .pipe(zod_1.z.number());
exports.stringAsNum = stringAsNum;
exports.cpfCnpjValidator = zod_1.z.string().transform(exports.removeCpfCharacters);
